// Cookie Plugin
cookie = function(){
	var site = 'darmstadtimherzen',
		lang = document.documentElement.lang,
		_html = document.querySelector('html'),
		desc = "Diese Seite verwendet Cookies für statistische Zwecke und dienen der korrekten Funktionsweise. Die Datenschutzbestimmungen können <a href='/datenschutz' title='Datenschutzbestimmungen'>hier</a> eingesehen werden.",
		btn = "Diese Nachricht nicht mehr anzeigen",
		info = "Datenschutzbestimmungen",
		btnLnk = 'datenschutz#cookieInfos';

	// console.log(document.cookie);
	// console.log('indexof: cc_'+site);
	// console.log(document.cookie.indexOf('cc_'+site))
	// console.log(document.cookie.indexOf('cc_'+site) < 0);


	if (document.cookie.indexOf('cc_'+site) < 0){
		if (lang == 'en'){
			desc = "We have placed cookies on your computer to help make this website better. You can change your cookie settings at any time. Otherwise, we’ll assume you're OK to continue.";
			btn = "Don't show me again";
			info = "Information about Cookies";
			btnLnk  = 'data-protection' // Link zu den Datenschutzbestimmungen
		}

		var c = document.createElement('div');
			c.className = "cookieWrap";
			linkbtn ='<a href="/'+btnLnk+'" class="infoCookiePolicy btn mini" title="'+info+'">I</a></div>';
			c.innerHTML = '<div class="cookiePolicy"><div class="cookiePolicyInner"><span class="cookieHeadline">Cookies:</span><p>'+desc+'</p></div><div class="buttons"><a href="#" class="closeCookiePolicy btn mini nomore" title="'+btn+'">'+btn+'</a> <a href="/'+btnLnk+'" class="btn mini nomore" title="'+info+'">'+info+'</a></div>';
		document.querySelector('body').insertBefore(c, document.querySelector('body').firstChild);

		// Click Functions
		document.querySelector('.cookieWrap .closeCookiePolicy.nomore').addEventListener('click', function(e){
			e.preventDefault();

			var cname = 'cc_'+site;
			var cvalue = '0';
			var exdays = '365';

			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+d.toUTCString();
			document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/";

			_html.className = "";

		});



		// document.querySelector('.cookieWrap .closeCookiePolicy').addEventListener('click', function(e){
		// 	e.preventDefault();
		// 	_html.className = "";
		// })

		//document.querySelector('.cookieWrap .infoCookiePolicy').addEventListener('click', function(e){
		//	_html.className = "";
		//});
	}
}
